import React from 'react';
import { Alert } from '@mui/material';
import { MotionSendResultDto } from '../../api/MotionSendResult';

/**
 * The outcome of a motion send, coloured so that only a real send to the court reads as success.
 * A draft is information; a copy routed to the internal mailbox is a warning, because it still has
 * to be filed by hand.
 *
 * `chartStep` names the case chart box a send records, for the motions that have one. Without it
 * nothing is said about the chart, because nothing was recorded there.
 */
interface Props {
  result: MotionSendResultDto;
  chartStep?: string;
}

const MotionSendResultAlert: React.FC<Props> = ({ result, chartStep }) => (
  <Alert
    severity={
      result.outcome === 'sent-to-court'
        ? 'success'
        : result.outcome === 'routed-internal'
          ? 'warning'
          : 'info'
    }
    sx={{ mt: 2 }}
  >
    {result.message}
    {chartStep &&
      result.outcome === 'sent-to-court' &&
      (result.filedStamped
        ? ' Recorded as filed on the case chart.'
        : ' It could not be recorded as filed on the case chart — record it there by hand.')}
    {chartStep &&
      result.outcome === 'draft-for-review' &&
      ` Once it has been sent, record it as filed on the case chart (${chartStep}).`}
  </Alert>
);

export default MotionSendResultAlert;
